import { createSlice } from "@reduxjs/toolkit";
import { resetPassword } from "./resetPassword.action";

const initialState = {
  isPasswordRecovering: false,
  isPassswordRecovered: false,
  isPasswordFailedToRecover: false,
};

const recoverPasswordSlicer = createSlice({
  name: "recoverPassword",
  initialState: initialState,
  extraReducers: {
    [resetPassword.pending]: (state) => {
      state.isPasswordRecovering = true;
    },
    [resetPassword.fulfilled]: (state) => {
      state.isPasswordRecovering = false;
      state.isPassswordRecovered = true;
    },
    [resetPassword.rejected]: (state) => {
      state.isPasswordRecovering = false;
      state.isPassswordRecovered = false;
      state.isPasswordFailedToRecover = true;
    },
  },
});

export default recoverPasswordSlicer.reducer;
